import React, {useRef, useEffect, useState} from "react";
import Layoutempty from "../../../components/mobile/Layout/layoutmobileempty";
import Layout from "../../../components/mobile/Layout/layoutmobile";
import {ckeckStatus,sendOTP,verifyOTP} from "../../../service/accountService";
import {getListBank} from "../../../service/bibomartNetService";
import {getCheckOrder, getOrderDetail, RefundInfo} from "../../../service/cartService";
import {Format2Degits, FormatDateDMYHM, FromatNumberVIE} from "../../../utils/format";
import { useTimer } from 'react-timer-hook';
import { toast } from 'react-toastify';
import { useLocation } from "@reach/router";
import HtmlParser from "react-html-parser";

import './css/hoantien.css'
const Hoantien = ()=>{
    const location = useLocation();
    const regexPhoneNumber = new RegExp(/(84|0[3|5|7|8|9])+([0-9]{8})\b/g);
      const time = new Date();
      time.setSeconds(time.getSeconds() + 300); 
      const {
        seconds,
        minutes,
        restart,
      } = useTimer({ time, onExpire: () => console.warn('onExpire called') });
        
      const phoneRef = useRef(null);
      const [showSendOTP, setShowSendOTP] = useState(false);
        let handleSendOTP = async (e)=>{
            e.preventDefault();
            if (regexPhoneNumber.test( phoneRef.current.value) === false) {
              toast.warning('Ba/Mẹ vui lòng nhập số điện thoại hợp lệ để tiếp tục');
              return;
            }   
            setShowOTP(true);
            setShowSendOTP(false);
            e.target.disabled = true;
            let _phone = phoneRef.current.value;
            try{
                  ckeckStatus({phone:_phone}).then((response) => {
                    let status = response["status"];
                    console.log(status);
                    if(status === 200){
                      sendOTP({
                        phone:_phone,
                        type:1
                      }).then((response)=>{
                        console.log(response["status"]);
                      })
                    }
                }); 
                const time = new Date();
                time.setSeconds(time.getSeconds() + 180);//180
                restart(time)

                setTimeout(() =>{
                    setShowSendOTP(true);
                } , 180000);//180000
              }catch(e){
                console.log(e);
              } 
        }
        const [useInfo, setUserInfo] = useState([]);
        let handleSubmit = async (e) => {
            e.preventDefault();
            const data = new FormData(e.target);
            let _phone = data.get('phone');
            let opt = data.get('otp');
            try{
        
              verifyOTP({
                phone:_phone,
                code: opt,
                type:1
              }).then((response)=>{
                if(response.status === 200){
                    if(response["message"]?.accessToken  && response["message"]?.accessToken !== '' && response["message"]?.accessToken !== undefined && response["message"]?.accessToken !== null){
                    toast.success('Đăng nhập thành công.');
                    window.localStorage.setItem('userReferral', '');
                    window.localStorage.setItem('idShare', '');
                    setUserInfo(response["message"]);
                    const params = Object.fromEntries(new URLSearchParams(location.search.substring(1)));
                    if(Object.keys(params).length>0){
                        loadOrderDetail(params['d'], response["message"]?.accessToken);
                    }
                    setShow(true);
                    }else{
                    toast.warning('Không thể đăng nhập được. Vui lòng kiểm tra lại đường truyền mạng.');
                    }
                    }else{
                    toast.warning('Không thể đăng nhập được. Vui lòng kiểm tra thông tin tài khoản.');
                    }
              });
           
            }catch(e){
              console.log(e);
            }
            console.log(useInfo);
        }


        const [listBank, setListBank] = useState([]);
        const loadBank =()=>{
            getListBank().then((response)=>{
                console.log(response);
                if(response.status === 200){
                    setListBank(response.message);
                }
            })
        }
        const [show, setShow] = useState(false);
        const [checkOrder, setCheckOrder] = useState(false);
        const [iconStatus, setIconStatus] = useState(0);
        const CheckOrderFG =(code)=>{
            getCheckOrder(code,  useInfo.accessToken).then((respose)=>{
                console.log(respose);
                if(respose.status === 200){
                    if(respose.message?.canRefund ===  0 && respose.message?.canSubmit ===  0){
                        //link không tồn tại
                        setStatusRefund("Rất tiếc, đường link bạn truy cập không hợp lệ<br/>Vui lòng kiểm tra lại hoặc liên hệ bộ phận hỗ trợ để được giúp đỡ");
                        setIconStatus(2);
                        setShowComplete(true);
                        setCheckOrder(false);
                    }
                    if(respose.message?.canRefund ===  1 && respose.message?.canSubmit ===  0){
                        // đã hoàn tiền
                        setStatusRefund("Yêu cầu hoàn tiền đã được tiếp nhận và đang xử lý<br/>Rất mong Quý khách sẽ có trải nghiệm tốt hơn ở lần mua kế tiếp" );
                        setIconStatus(1);
                        setShowComplete(true);
                        setCheckOrder(false);
                    }
                    if(respose.message?.canRefund ===  1 && respose.message?.canSubmit ===  1){
                        //đăng nhập để hoàn tiền
                        setStatusRefund("Đơn hàng cần hoàn tiền- đăng nhập");
                        setCheckOrder(true);
                    }
                }
            })
        }

        const [orderDetail, setOrderDetail] = useState([]);
        const loadOrderDetail =(code, token)=>{
            setCheckOrder(false);
            getOrderDetail(code, token).then((response)=>{
                if(response.status === 200){
                    setOrderDetail(response.message);
                    setCheckOrder(true);
                }
                if(response.status === 400){
                    setCheckOrder(false);
                    setStatusRefund("Rất tiếc, số điện thoại đăng nhập không đúng với số điện thoại đặt hàng<br/>Vui lòng kiểm tra lại hoặc liên hệ bộ phận hỗ trợ để được giúp đỡ");
                    setIconStatus(3);
                    setShowComplete(true);
                   
                }
            })
        }
        const [showComplete, setShowComplete] = useState(false);

        useEffect(()=>{

            const params = Object.fromEntries(new URLSearchParams(location.search.substring(1)));
            if(Object.keys(params).length>0){
                CheckOrderFG(params['d']);
            }

            // CheckOrder('CA/241216/MCH49RZQ', );
            setShow(false);
            setShowComplete(false);
            setShowOTP(null);
            loadBank();
            setShowSendOTP(false);

        },[])
        const bankSwiffCode = useRef(null);
        const bankAccount = useRef(null);
        const bankAccountName = useRef(null);
        const phoneNumber = useRef(null);
        const [statusRefund, setStatusRefund] = useState();
        const handleSend=()=>{
            if (regexPhoneNumber.test(phoneNumber.current.value) === false) {
                toast.warning('Ba/Mẹ vui lòng nhập số điện thoại hợp lệ để tiếp tục');
                return;
            }
            let params ={
                'orderId':orderDetail._id,
                'bankSwiffCode': bankSwiffCode.current.value,
                'bankAccount': bankAccount.current.value,
                'bankAccountName': bankAccountName.current.value,
                'phoneNumber': phoneNumber.current.value

            }
            console.log(params);
            if(orderDetail._id !== '', bankSwiffCode.current.value !== '' && bankAccount.current.value !== '' && bankAccountName.current.value !== '', phoneNumber.current.value !== ''){
                RefundInfo(params, useInfo.accessToken).then((response)=>{
                    if(response.status === 200){
                        setShowComplete(true);
                        setCheckOrder(null);
                        setStatusRefund('Gửi thông tin thành công <br/>Cảm ơn Quý Khách!');
                        setIconStatus(1);
                    }else{
                        setStatusRefund(response.message);
                        toast.warning(response.message);
                        setCheckOrder(true);
                        setShowComplete(false);
                    }
                })
            }else{
                toast.warning('Quý khách cần cung cấp đủ thông tin');
            }
        }
        const handleClick=(uri)=>{
            window.location.href = uri;
        } 
        const handleBack = () => {
            window.history.back();
          }
    const [showOTP,setShowOTP] = useState(false);

    const handleGoHoome=()=>{
        window.location.href = location.origin;
    }
    

    return(
            <>
                {
                    checkOrder ? (
                        
                        show === false?(
                            <Layoutempty>
                                <div className="container1">
                                <div className="header1 flex-col-nowrap">
                                <div className="row mgt-10">
                                    <div onClick={()=>handleBack()} className="col-2 in-f">
                                        <img src="/../images/voucher/ic_back.svg" alt="icon"/>
                                    </div>
                                    <div className="col-8 in-f">
                                        <strong className="text_header color_gray">TÀI KHOẢN</strong>
                                    </div>
                                    <div className="col-2 in-f">
                                    <a onClick={()=>handleClick('/')}>
                                        <img src="/../images/account/home.svg" alt="icon"/>
                                    </a>
                                    </div>
                                </div>
                                    <div className="row mgt-10">
                                        <div className="col-12 text-center">
                                            <div className="position-relative">
                                                <img src="/../images/account/banner.png" alt="icon"/>
                                            </div>
                                            <span className="position-absolute banner_custom">
                                                <img className="position-relative top-0" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/account_user.png" alt="icon"/>
                                            </span>
                                            <span className="position-absolute logo_custom">
                                                <img className="position-relative top-0" src="/../images/account/logo_bibo-05.png" alt="icon"/>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row mgt-30">
                                        <div className="col-12 text-center mgt-10">
                                            <strong className="text_dn">Đăng nhập</strong>
                                            <div className="row">
                                                <div className='col-12 pdx-0 ps-4 pe-4'>
                                                    <span className='text-center'>Vui lòng đăng nhập để cung cấp thông tin nhận hoàn tiền cho đơn hàng</span>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                <form className='form-login-mb mgx-0' onSubmit={handleSubmit}>
                                <div className='row mgt-10 mgx-0 pdx-30 bg-index pdy-24'>
                                    <div className='col-12 pdx-0'>

                                        <div className='row mgx-0'>
                                        <span className='login-nav-textnum-mb col-12 pdx-0'>Số điện thoại <span className='color_red'>*</span></span>
                                        <div className="login-futter-mb col-12 mgt-10">
                                        <input className="login-input-mb error" type="" required ref={phoneRef} 
                                        name="phone" placeholder="Nhập số điện thoại"/>
                                        {
                                            showSendOTP === true && (minutes === 0 && seconds === 0) ?
                                            (<button type="submit" className="btn btn-primary-mb text_12 font_700" onClick={handleSendOTP}>Gửi OTP</button>)
                                            :(null)
                                        }
                                        {
                                            showOTP === true && showSendOTP === false?
                                            (<div className="countdown">{Format2Degits(minutes)}:{Format2Degits(seconds)}</div>)
                                            :(null)
                                        }
                                        </div>
                                            {
                                            showOTP === true ? (
                                                <>
                                                <div className='pdx-0 mgt-10'><span className='login-nav-textnum-mb col-12 mgt-10'>Mã xác thực <span className='color_red'>*</span></span>
                                                    <div className="login-futter-mb col-12 mgt-10">
                                                        <input className="confirm-input-mb" type="number" id="" name="otp" placeholder="Nhập mã OTP vừa gửi đến điện thoại của Bạn"/>
                                                    </div>
                                                </div>
    
                                                <div className='login-foot-mb col-12 mgt-10 pdb-10'>
                                                    <div className="login-button-mb">
                                                        <div style={{height:10}}></div>
                                                        <button type="submit" className="button-login-mb">Đăng nhập</button> 
                                                    </div>
                                                </div>
                                                </>
                                            ):(
                                            <>
                                            <div style={{height:20}}></div>
                                            <button type="submit" className="button-login-mb" onClick={handleSendOTP}>Gửi OTP</button>
                                            </>)
                                            }
                                            {/* <button type="submit" className="button-login-mb">Đăng nhập</button>  */}
                                           
                                        
                                      </div>
                                    </div>
                                </div>
                                </form>
                                </div>
                                </div>
                            </Layoutempty>
                        ):(
                            <Layoutempty>
                                <div className="container1  refund-payment">
                                <div className="row mgt-10">
                                    <div onClick={()=>handleBack()} className="col-2 in-f">
                                        <img src="/../images/voucher/ic_back.svg" alt="icon"/>
                                    </div>
                                    <div className="col-8 in-f">
                                        <strong className="text_header color_gray">HOÀN TIỀN</strong>
                                    </div>
                                    <div className="col-2 in-f">
                                    <a onClick={()=>handleClick('/')}>
                                        <img src="/../images/account/home.svg" alt="icon"/>
                                    </a>
                                    </div>
                                </div>

                            <div className="row">
                                <div className=''>
                                    <div className='login-header'>
                                        <div className='row pe-2 login-header-title'>CUNG CẤP THÔNG TIN TÀI KHOẢN <br/>HOÀN TIỀN</div>
                                    </div>
                                </div>
                                <div className="row ">
                                    <div>Kính gửi: Quý khách hàng, <span className="use-name">{useInfo.user?.name}</span></div>
                                    <div>Xin cảm ơn Quý khách đã tin tưởng lựa chọn sản phẩm tại Bibo Mart.</div>
                                    <div className="title-order">Thông tin đơn hàng:</div>
                                    <div>
                                        <ul className="order-detail">
                                            <li>Mã đơn hàng: <span className="use-name">{orderDetail.sale ?? orderDetail.code}</span> </li>
                                            <li>Ngày: <span className="use-name">{FormatDateDMYHM(orderDetail.created)}</span></li>
                                            <li>Giá trị đơn hàng: <span className="use-name">{FromatNumberVIE(orderDetail.total)}đ</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="row ">
                                    <div className="row column ">
                                        <div className="col-7">Danh sách sản phẩm</div>
                                        <div className="col-2 text-center">Số lượng</div>
                                        <div className="col-3 text-center">Thành tiền</div>
                                    </div>
                                    {
                                        orderDetail.items ? (
                                            orderDetail.items.map((item)=>{
                                                return <div className="row column ">
                                                            <div className="col-7">{item.product?.name}</div>
                                                            <div className="col-2 text-center">x{FromatNumberVIE(item.quantity)}</div>
                                                            <div className="col-3 text-right">{FromatNumberVIE(item.amount)}đ</div>
                                                        </div>
                                            })
                                        ):(null)
                                    }

                                </div>
                                <div className="row  note-refund">
                                    <span>
                                        Bibo Mart rất xin lỗi Quý Khách đơn hàng đã không được xử lý thành công. 
                                        Quý Khách vui lòng cung cấp các thông tin dưới đây để Bibo Mart thực hiện hoàn tiền cho đơn hàng.
                                    </span>  
                                </div>
                                <div className="title-payment">Thông tin tài khoản nhận hoàn tiền</div>
                                <div className="row">
                                    <div className="col-12"> 
                                        <div className="mb-3">
                                            <label for="exampleFormControlInput1" className="form-label"><span className="text-red">*</span> Ngân hàng</label>
                                            {/* <input type="text" className="form-control" id="exampleFormControlInput1" placeholder=""/> */}
                                            
                                            <select id="bank" ref={bankSwiffCode} name="bank" className="form-select mb-3" aria-label="Large select example">
                                                <option value="" className="w-100">Chọn ngân hàng</option>
                                                {
                                                    listBank.map((item)=>{
                                                        return <option value={item.swiffCode}>{item.fullName}({item.brandName})</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12"> 
                                        <div className="mb-3">
                                            <label for="exampleFormControlInput1" className="form-label"><span className="text-red">*</span> Số tài khoản</label>
                                            <input type="text" ref={bankAccount} className="form-control" id="exampleFormControlInput1" placeholder="Số tài khoản"/>
                                            <span className="note-input">Không nhập tên định danh thay cho số tài khoản (alias)</span>
                                        </div>
                                    </div>
                                    <div className="col-12"> 
                                        <div className="mb-3">
                                            <label for="exampleFormControlInput1" className="form-label"><span className="text-red">*</span> Tên chủ tài khoản</label>
                                            <input type="text" ref={bankAccountName} className="form-control" id="exampleFormControlInput1" placeholder="NGUYEN VAN A"/>
                                            <span className="note">Nhập tên In hoa và không dấu</span>
                                        </div>
                                    </div>
                                    <div className="col-12"> 
                                        <div className="mb-3">
                                            <label for="exampleFormControlInput1" className="form-label"><span className="text-red">*</span> Số điện thoại</label>
                                            <input type="phone" ref={phoneNumber} className="form-control" id="exampleFormControlInput1" placeholder="Nhập số điện thoại liên hệ"/>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="warning">
                                    {/* Lưu ý:<br/>
                                    Việc nhập thông tin không chính xác sẽ khiến giao dịch bị từ chối và Quý khách sẽ chịu mọi chi phí liên quan đến quá trình xử lý yêu cầu. */}
                                     Lưu ý:
                                    <ul className="warning-list">
                                        <li>
                                            Việc nhập thông tin không chính xác sẽ khiến giao dịch bị từ chối và Quý khách sẽ chịu mọi chi phí liên quan đến quá trình xử lý yêu cầu.
                                        </li>
                                        <li>
                                            Quý khách nhập đúng Số tài khoản ngân hàng, không nhập tên định danh thay thế cho số tài khoản (alias)
                                        </li>
                                    </ul>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="check-confirm pe-10">
                                        <input className="form-check-input" disabled type="checkbox" name="current" id="flexCheckDefault" defaultChecked required/>
                                        <span> Tôi đã đọc và đồng ý với các <a className='red' href='/dieu-khoan-hoan-tien.html' target="_blank">Điều khoản hoàn tiền</a> của Bibo Mart</span>
                                    </div>
                                </div>
                                
                                
                                <div className='login-foot'>
                                    <div className="login-button">
                                        <button id="button-login" className="button-login" onClick={()=>handleSend('/')}>YÊU CẦU HOÀN TIỀN</button>
                                    </div>
                                </div>
                                <div style={{paddingBottom:24}}></div>
                                <div className="row note">
                                    <div className="text-center">
                                        Nếu có bất kỳ thắc mắc nào Quý Khách vui lòng liên hệ:
                                    </div>
                                    <div className="text-center">
                                        Hotline: <span className="text-red">1800 68 86</span> (Miễn phí) hoặc <img src="/static/image/zalo-logo.svg" alt="" />     
                                    </div>
                                </div>
                            </div>

                            </div>
                            </Layoutempty>
                        )
                    
                    ):(
                        null
                    )
                }
               
                {
                showComplete ? (
                    <Layoutempty>
                            <div className="row mgt-10">
                                <div onClick={()=>handleBack()} className="col-2 in-f">
                                    <img src="/../images/voucher/ic_back.svg" alt="icon"/>
                                </div>
                                <div className="col-8 in-f">
                                    <strong className="text_header color_gray">HOÀN TIỀN</strong>
                                </div>
                                <div className="col-2 in-f">
                                <a onClick={()=>handleClick('/')}>
                                    <img src="/../images/account/home.svg" alt="icon"/>
                                </a>
                                </div>
                            </div>
                    <div className='row container-page-refund refund-payment refund-payment-mobile'>
                        <div className=''>
                            <div className='row login d-flex justify-content-center'>
                                <div className='login-box'>
                                    <div className='login-header'>
                                        <span className='login-header-title text-center'></span>
                                        {/* <i class="bi bi-check-circle"></i>
                                        <span className='text-complete'>{statusRefund}</span> */}
                                        {
                                            iconStatus === 1 ?( <i className="bi bi-check-circle"></i>):(null)
                                        }
                                        {
                                            iconStatus === 2 ?( <span class="text-complete">
                                                <img src="/static/image/linknull.png" />
                                            </span>):(null)
                                        }
                                        {
                                            iconStatus === 3 ?( <span class="text-complete">
                                                <img src="/static/image/empty.png" />
                                            </span>):(null)
                                        }
                                        <div className='text-complete'>{HtmlParser(statusRefund)}</div>
                                        <div className='login-footer'>
                                            <div className="login-button">
                                                <button id="button-login" className="btn-gohome" onClick={()=>handleGoHoome()}>TRANG CHỦ</button>
                                            </div>
                                        </div>

                                        <div className="row note">
                                            <div className="text-center">
                                                Nếu có bất kỳ thắc mắc nào Quý Khách vui lòng liên hệ:
                                            </div>
                                            <div className="text-center">
                                                Hotline: <span className="text-red">1800 68 86</span> (Miễn phí) hoặc <img src="/static/image/zalo-logo.svg" alt="" />     
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{height:150}}></div>
                        </div>
                    </div>
                    </Layoutempty>
                ):(null)
                }
            </>
      
        
    )
}
export default Hoantien;